export enum ActionType {
  SET_ASSET_DETAILS = "SET_ASSET_DETAILS",
};


interface AssetDetailsAction {
  type: ActionType.SET_ASSET_DETAILS,
  payload: {
    name: string,
    description: string,
    price: number,
    count: number,
    isSold: boolean,
  }
}


export type Action = AssetDetailsAction;
